import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'rsman';
  public token: any;
  public toolbar_title: string = "Devices";
  public componentName: string = "devices";

  public loginPage = false;
  public pageTitle = 'Devices';

  constructor(
    private router: Router,
    private globalvar: GlobalvarsService,
    private location: Location
  ) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url == '/logon') {
          this.loginPage = true
        } else {
          this.loginPage = false
          switch (true) {
            case this.router.url.includes('device'):
              this.pageTitle = "Devices"
              break;
            case this.router.url.includes('scenario'):
              this.pageTitle = "Scenarios"
              break;
            case this.router.url.includes('department'):
              this.pageTitle = "Departments"
              break;
            case this.router.url.includes('user'):
              this.pageTitle = "Users"
              break;
          }
        }
      }
    });
  }

  ngOnInit(): void {

    // Make sure we are logged in with a valid user
    this.globalvar.getToken.subscribe(token => {
      this.token = token;
    });

    if (this.token === '') {
      this.router.navigateByUrl('/logon');
    } else {
      //
    }
  }

  logoff() {
    this.token = ''
    this.globalvar.storeToken('');
    this.router.navigateByUrl('/logon');
  }
}
